import React, { ReactNode, useState } from 'react';
import { Modal } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';

type Props = {
  children: ReactNode,
  width: number,
  showBtnExit: boolean,
  squareWidth: string,
  onLogout?: () => void

}

type SquareTitleProps = {
  squareWidth: string,
}

const SquareTitle = styled.div<SquareTitleProps>`
  width: ${props => props.squareWidth || '100%'} ;
  height: 90px;
  background: linear-gradient(260.91deg, rgba(45, 15, 71, 0.9) 0%, rgba(78, 27, 117, 0.9) 100%);
  top: -30px;
  position: absolute;
  box-shadow: 0 2px 16px 0 #00000040;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFF;
  border-radius: 15px;
  margin: 0 0 0 16px;
  font-size: 16pt;
  font-weight: 400;
  white-space: nowrap;

  // Adjusts square title size when on mobile
  @media (max-width: 600px) {
      width: 60%;
  }
`;

const TextExit = styled.span`
  margin: 0 32px 0 8px;
  font-size: 14px;
  font-weight: 900;
`;

const CloseIcon = styled.div`
  display: flex;
  flex-direction: row;
`;

interface StyledModalProps {
  showBtnExit : boolean,
}

const CustomModal = styled(Modal)<StyledModalProps>`
  @media only screen and (max-width: 1000px) {

    .ant-modal-content {
      margin-top: 96px;
    }
  }

  .ant-modal-content {
    border-radius: 12px;
  }

  ${props =>
    props.showBtnExit &&
      css`
        .ant-modal-content {
          padding: 0;
        }

        .ant-modal-body {
          padding: 16px 16px;
        }

        .ant-modal-header {
          height: 60px;
          padding: 16px 16px;
          box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.15);
        }
        .ant-modal-close:hover {
          background: none;
          border: none;
        }
      `}
`;

const DefaultModal: React.FC<Props> = ({ children, width, showBtnExit, squareWidth, onLogout }: Props) => {
  const [open, setOpen] = useState(true);

  return (
    <CustomModal
      centered
      open={open}
      onOk={() => setOpen(false)}
      closeIcon={showBtnExit ? (<CloseIcon onClick={onLogout}><LogoutOutlined style={{ cursor: 'pointer' }} /> <TextExit>Sair</TextExit> </CloseIcon>) : null}
      footer={<></>}
      width={width}
      title={(<SquareTitle squareWidth={squareWidth}>Admissão Digital</SquareTitle>)}
      style={{ marginTop: '64px' }}
      showBtnExit={showBtnExit}
    >
      {children}
    </CustomModal>
  );
};

export default DefaultModal;
